import React, { useContext } from 'react';
import NoResultsFound from 'components/NoResultsFound/NoResultsFound';
import NoFiltersChangePosition from 'components/NoFiltersChangePosition/NoFiltersChangePosition';
import ChangePositionControlPanel from './components/ChangePositionControlPanel/ChangePositionControlPanel';
import ChangePositionList from './components/ChangePositionList/ChangePositionList';
import AdditionalRestaurantsModal from './components/AdditionalRestaurantsModal/AdditionalRestaurantsModal';
import ModalWindows from './components/ModalWindows/ModalWindows';
import BtnBlock from './components/BtnBlock';
import { AppContext, IAppContext } from 'appState/appContext';
import {
	ChangeGamePositionContext,
	IChangeGamePositionContext,
} from '../../changeGamePositionState/changeGamePositionContext';
import style from './ChangeGamePosition.module.scss';

const ChangeGamePosition: React.FC = () => {
	const { positionsData, IDSelectedRestaurant } = useContext<IChangeGamePositionContext>(ChangeGamePositionContext);
	const { isLoading } = useContext<IAppContext>(AppContext);

	return (
		<div className={style.container} data-test="ChangeGamePosition">
			<ChangePositionControlPanel />
			{positionsData?.length ? (
				<>
					<ChangePositionList />
					<BtnBlock />
					<ModalWindows />
					<AdditionalRestaurantsModal />
				</>
			) : (
				<NoResultsFound isVisible={!isLoading && !!IDSelectedRestaurant} />
			)}
			<NoFiltersChangePosition isVisible={!IDSelectedRestaurant} />
		</div>
	);
};

export default ChangeGamePosition;
